import { SummarySection } from "./summaryDetailInfo";

export default class UserInfo2 {
  displayName: string;
  providerId: string;
  email: string;
  uid: string;
  isAnonymous: boolean;
  photoURL: string | null;
  documentProcessedTotal: number = 0;
  documentProcessedLastDay: number = 0;
  documentProcessedLastDate: Date = new Date();
  lastLogin: Date = new Date();
  businessName: string = '';
  businessAddress: string = '';
  createdOn: Date = new Date();
  modifiedOn: Date = new Date();
  coupon: string = '';
  documentProcessedLastDayDate?: Date = new Date();
  lists: string[] = [];  // Deprecated: use listIds instead
  listIds: string[] = [];  // New field name for user's list IDs
  pdfUrl?: string;
  emailBody?: any;
  emailBodyUpdatedOnL?: number; // Timestamp (milliseconds) when email body was last updated
  stripeCustomerId?: string;

  // Audio briefing URLs for different times of day
  audioUrl1?: string;  // Before market opens (pre-9:30 AM ET)
  audioUrl2?: string;  // Mid-day briefing (9:30 AM - 4:00 PM ET)
  audioUrl3?: string;  // After market close (post-4:00 PM ET)
  audioUrlUpdatedAt?: Date;  // Track when audio URLs were last updated
  hasActiveSubscription: boolean;
  isAdmin: boolean = false;
  emailVerified: boolean = false;
  sendReport: boolean = false; // Flag to indicate if a newsletter should be sent to this user
  mergeReservedList: boolean = false; // Flag to indicate if reserved lists should be merged with user lists

  // Summary fields
  summaryHeader?: string; // Attention-grabbing headline for the summary
  shortSummary?: string; // Abbreviated version of the summary for previews
  summary?: string; // Main summary content
  summaryFull?: SummarySection[]; // Complete detailed summary
  summaryReadTime?: number; // Estimated reading time in minutes
  summarizedOn?: Date; // Timestamp when the summary was generated
  summaryBatchId?: string; // ID of the batch that generated this summary
  currentBatchId?: string; // ID of the current batch for this user
  currentBatchTime?: Date; // Timestamp of the current batch assignment

  // Sentiment Rolling History
  sentimentScore1?: number;
  sentimentTime1?: Date;
  sentimentScore2?: number;
  sentimentTime2?: Date;
  sentimentScore3?: number;
  sentimentTime3?: Date;

  constructor(user: any) {
    // Basic Auth fields
    this.uid = user.uid;
    this.email = user.email || user.providerData?.[0]?.email || '';
    this.displayName = user.displayName || (user.providerData?.[0]?.displayName) || '';
    this.providerId = user.providerData?.[0]?.providerId || '';
    this.isAnonymous = user.isAnonymous || false;
    this.photoURL = user.photoURL || user.providerData?.[0]?.photoURL || null;
    this.emailVerified = user.emailVerified || false;

    // Additional data fields
    this.isAdmin = user.isAdmin || false;
    this.hasActiveSubscription = user.hasActiveSubscription || false;
    this.documentProcessedTotal = user.documentProcessedTotal || 0;
    this.documentProcessedLastDay = user.documentProcessedLastDay || 0;
    this.businessName = user.businessName || '';
    this.businessAddress = user.businessAddress || '';
    this.coupon = user.coupon || '';
    this.lists = user.lists || [];
    this.listIds = user.listIds || [];
    this.pdfUrl = user.pdfUrl;
    this.emailBody = user.emailBody;
    this.emailBodyUpdatedOnL = user.emailBodyUpdatedOnL;
    this.stripeCustomerId = user.stripeCustomerId;
    this.sendReport = user.sendReport || false;
    this.mergeReservedList = user.mergeReservedList || false;

    // Audio briefing URLs
    this.audioUrl1 = user.audioUrl1;
    this.audioUrl2 = user.audioUrl2;
    this.audioUrl3 = user.audioUrl3;
    this.audioUrlUpdatedAt = user.audioUrlUpdatedAt instanceof Date ? user.audioUrlUpdatedAt : (user.audioUrlUpdatedAt?.toDate?.());

    // Summary fields
    this.summaryHeader = user.summaryHeader;
    this.shortSummary = user.shortSummary;
    this.summary = user.summary;
    this.summaryFull = user.summaryFull;
    this.summaryReadTime = user.summaryReadTime;
    this.summarizedOn = user.summarizedOn instanceof Date ? user.summarizedOn : (user.summarizedOn?.toDate?.() || user.summarizedOn);
    this.summaryBatchId = user.summaryBatchId;
    this.currentBatchId = user.currentBatchId;
    this.currentBatchTime = user.currentBatchTime instanceof Date ? user.currentBatchTime : (user.currentBatchTime?.toDate?.() || user.currentBatchTime);

    // Date fields
    this.documentProcessedLastDate = user.documentProcessedLastDate instanceof Date ? user.documentProcessedLastDate : (user.documentProcessedLastDate?.toDate?.() || new Date());
    this.lastLogin = user.lastLogin instanceof Date ? user.lastLogin : (user.lastLogin?.toDate?.() || new Date());
    this.createdOn = user.createdOn instanceof Date ? user.createdOn : (user.createdOn?.toDate?.() || new Date());
    this.modifiedOn = user.modifiedOn instanceof Date ? user.modifiedOn : (user.modifiedOn?.toDate?.() || new Date());
    this.documentProcessedLastDayDate = user.documentProcessedLastDayDate instanceof Date ? user.documentProcessedLastDayDate : (user.documentProcessedLastDayDate?.toDate?.() || new Date());

    // Sentiment fields
    this.sentimentScore1 = user.sentimentScore1;
    this.sentimentTime1 = user.sentimentTime1 instanceof Date ? user.sentimentTime1 : (user.sentimentTime1?.toDate?.());
    this.sentimentScore2 = user.sentimentScore2;
    this.sentimentTime2 = user.sentimentTime2 instanceof Date ? user.sentimentTime2 : (user.sentimentTime2?.toDate?.());
    this.sentimentScore3 = user.sentimentScore3;
    this.sentimentTime3 = user.sentimentTime3 instanceof Date ? user.sentimentTime3 : (user.sentimentTime3?.toDate?.());
  }
}
